import {Component, OnInit} from '@angular/core';
import {UserModel} from '../../../../../models/authentication/user.model';
import {CsvImportService} from '../../../../../services/reusable/csv-import.service';
import {ModalService} from '../../../../../shared/modals/modal/modal.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {TeacherInvitationModel} from '../../../../../models/authentication/teacher-invitation';
import {AdminSchoolUserInvitationService} from '../../../../../services/admin/admin-school-user-invitation.service';
import {StringExtensionModel} from '../../../../../models/extensions/string-extension.model';

@Component({
  selector: 'app-evo-school-school-upload-users-invitations',
  templateUrl: './evo-admin-school-upload-users-invitations.component.html',
  styleUrls: ['./evo-admin-school-upload-users-invitations.component.css']
})
export class EvoAdminSchoolUploadUsersInvitationsComponent implements OnInit {

  usersToInvite: TeacherInvitationModel[] = [];
  schoolId: string = null;
  isDisabled = false;
  public AccessTypes = UserModel.SchoolAccessTypesDropdown;

  constructor(private csvSv: CsvImportService,
              private modalSv: ModalService,
              private route: ActivatedRoute,
              private userInvitationSv: AdminSchoolUserInvitationService,
              private router: Router) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params.schoolId) {
        this.schoolId = params.schoolId;
      }
    });
  }

  onFileChanged(event) {

    if (event.target.files.length > 0) {

      const currentFile = event.target.files[0];

      const properties = ['Email', 'Full Name'];
      this.csvSv.importAllProperties(currentFile).subscribe((objects) => {

        this.usersToInvite = [];
        for (const userToInviteBody of objects) {

          const userToInvite = new TeacherInvitationModel();

          for (const property of properties) {

            if (property === 'Email') {

              const email = userToInviteBody[property];
              if (email) {
                userToInvite.email = email.toLowerCase();
              }

            } else if (property === 'Full Name') {

              const fullName: string = userToInviteBody[property];
              const names = StringExtensionModel.separateFullName(fullName, false);
              userToInvite.setNames(names);

            }

            userToInvite.schoolId = this.schoolId;
            userToInvite.schoolAccessType = TeacherInvitationModel.SchoolAccessTypes.teacher;

          }

          if (userToInvite.email || userToInvite.firstName || userToInvite.lastName) {
            this.usersToInvite.push(userToInvite);
          }
        }
      });
    }
  }

  onCancelClicked() {
    this.router.navigate(['admin', 'schools', this.schoolId, 'invitations']);
  }

  onCreateClicked() {
    this.isDisabled = true;
    this.userInvitationSv.importUsersInvitations(this.usersToInvite, this.schoolId).subscribe((usersInvitationsCount) => {
      this.isDisabled = false;
      this.modalSv.showAlertModal('Success', usersInvitationsCount + ' users successfully invited').subscribe(() => {
        this.router.navigate(['admin', 'schools', this.schoolId, 'invitations']);
      });
    }, (err) => {
      this.isDisabled = false;
      this.modalSv.showErrorModal('Error', err.message).subscribe(() => {
        this.router.navigate(['admin', 'schools', this.schoolId, 'invitations']);
      });
    });
  }

}
